import {DocumentTemplateGroupAPI} from "../api/DocumentTemplateGroupAPI";
import {RsDocumentTemplateGroup} from "../api/dto/RsDocumentTemplateGroup";

export class DocumentTemplateGroupService {

    private static instance: DocumentTemplateGroupService;
    private documentTemplateGroupApi: DocumentTemplateGroupAPI;

    private constructor() {
        this.documentTemplateGroupApi = new DocumentTemplateGroupAPI();
    }

    async retrieveDocumentTemplateGroupsByVerificationId(verificationId: string): Promise<RsDocumentTemplateGroup[]> {
        return await this.documentTemplateGroupApi.retrieveDocumentTemplateGroupsByVerificationId(verificationId);
    }

    static getInstance(): DocumentTemplateGroupService {
        if (!this.instance) {
            this.instance = new DocumentTemplateGroupService();
        }
        return this.instance;
    }

}